import axiosSync from "@/axiosSync";

export function usePortInfoTbsEponApi() {
  async function getSysStatus(olt_id) {
    const response = await axiosSync.get(`/tbs-epon?oltid=${olt_id}&type=getSysStatus&url=${process.env.VUE_APP_API_BASE_URL}`);
    return response.data;
  }
  
  async function getPortBasicList(olt_id) {
    const response = await axiosSync.get(`/tbs-epon?oltid=${olt_id}&type=getPortBasicList&url=${process.env.VUE_APP_API_BASE_URL}`);
    return response.data;
  }
  
  async function getPortOptical(olt_id) {
    const response = await axiosSync.get(`/tbs-epon?oltid=${olt_id}&type=getPortOptical&url=${process.env.VUE_APP_API_BASE_URL}`);
    return response.data;
  }

  async function getOnuRealtime(olt_id, ponPortName, onuId) {
    const response = await axiosSync.get(`/tbs-epon?oltid=${olt_id}&type=onurealtime&url=${process.env.VUE_APP_API_BASE_URL}&PonPortName=${ponPortName}&onuId=${onuId}`);
    return response.data;
  }

  return {
    getSysStatus,
    getPortBasicList,
    getPortOptical,
    getOnuRealtime,
  };
}

